
const env = () => {
  if (window.location.origin.includes('http://sdea004:8080')) {
    return "dev";
  } else if (window.location.origin.includes('http://ssta004:8080')) {
    return "sit";
  } else if (window.location.origin.includes('http://sppa012:8080')) {
    return "preprod";
  } else if (window.location.origin.includes('http://localhost:3000')) {
    return "prod";
  } else {
    return "prod";
  }
}

const getAppIndex = () => {
  let index
  if (env() === "dev" || env() === "sit")
    index = 'BM_Test_EN_AR_Series'
  else
    index = `${env()}_devices_series`
  return index
}

const getSortIndex = () => {
  let index
  if (env() === "dev" || env() === "sit")
    index = {
      popular: 'BM_Test_EN_AR_Series_Featured',
      asc: 'BM_Test_EN_AR_Series_Price_Asc',
      desc: 'BM_Test_EN_AR_Series_Price_Desc',
      newer: 'BM_Test_EN_AR_Series_Latest',
    }
  else
    index = {
      popular: `${env()}_devices_series_sort_featured`,
      asc: `${env()}_devices_series_sort_price_asc`,
      desc: `${env()}_devices_series_sort_price_desc`,
      newer: `${env()}_devices_series_sort _latest`,
    }

  return index
}

export { getAppIndex, getSortIndex }
